export const CREDIT_APPLICATION_EXPORT_ID = "Solicitud de credito";
export const CREDIT_APPLICATION_TITLE = "Solicitud de credito";

export const CREDIT_APPLICATION_PROPERTIES = {
    id: "# solicitud",
    username: "Usuario",        
    businessPartner: "Cliente",
    creationDateTime: 'Fecha de Creacion',
    amountCreditRequested: 'Límite solicitado',
    amountCreditApproved: 'Límite aprobado',
    approvalDate: 'Fecha de aprobación',
    approvalUser: 'Usuario aprobador',
    reasonRejection: 'Motivo de rechazo',
    statusId: 'Estado',
};

export const DATE_FIELDS = [
    "creationDateTime",
    "approvalDate"
];

export const CURRENCYFIELDS = [
  "amountCreditApproved",
  "amountCreditRequested"
];

export const FORMATTER = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const DATE_TIME_FORMATTER = new Intl.DateTimeFormat("es-HN", {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
//   second: '2-digit',
//   hour12: false // Formato 24 horas
});

export const CREDIT_APPLICATION_STATUS_TEXTS: Record<number, string> = {
  1: "Activo",
  0: "Anulado",
  6: "En progreso",
  7: "Aprobado",
  14: "Aprobado Parcialmente",
  8: "Rechazado",
};